// @tennis-matches/services/trainerstunden/session-external-court
import { getSupabaseClient } from "../supabase/index.js";

function __asStr(v) {
  return String(v ?? "").trim();
}

/** @param {unknown} raw */
export function parseSessionCourtNoFromLabel(raw) {
  const s = __asStr(raw);
  if (!s) return null;
  const m = s.match(/platz\s*(\d+)/i) || s.match(/^(\d+)$/);
  if (!m) return null;
  const n = Number(m[1]);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * CheckCourt-/externe Platzbuchungen an Sessions hängen.
 * @param {object[]} sessions
 * @returns {Promise<object[]>}
 */
export async function attachSessionExternalCourtBookings(sessions) {
  const list = Array.isArray(sessions) ? sessions : [];
  const ids = [...new Set(list.map((s) => __asStr(s?.id)).filter(Boolean))];
  if (!ids.length) return list;
  try {
    const supabase = await getSupabaseClient();
    if (!supabase) return list;
    const { data, error } = await supabase
      .from("trainerstunden_session_external_bookings")
      .select(
        "session_id, external_court_id, external_court_name, cancelled_at",
      )
      .in("session_id", ids)
      .is("cancelled_at", null);
    if (error) {
      console.warn("[attachSessionExternalCourtBookings] Error:", error);
      return list;
    }
    const bySession = new Map();
    for (const row of data || []) {
      const sid = __asStr(row?.session_id);
      if (!sid || bySession.has(sid)) continue;
      bySession.set(sid, row);
    }
    return list.map((session) => {
      const sid = __asStr(session?.id);
      const booking = bySession.get(sid);
      if (!booking) return session;
      const courtName =
        __asStr(booking.external_court_name) ||
        (__asStr(booking.external_court_id)
          ? `Platz ${__asStr(booking.external_court_id)}`
          : "");
      if (!courtName) return { ...session, courtBooked: true };
      return {
        ...session,
        external_court_name: courtName,
        courtLabel: courtName,
        courtNo: parseSessionCourtNoFromLabel(courtName),
        courtBooked: true,
      };
    });
  } catch (e) {
    console.warn("[attachSessionExternalCourtBookings] Exception:", e);
    return list;
  }
}

/**
 * Ort + Platz (+ „gebucht“) für Listen/Hero.
 * @param {object|null|undefined} session
 * @param {string} locationLabel
 * @param {(key: string, params?: object) => string} t
 */
export function formatSessionPlaceWithCourt(session, locationLabel, t) {
  const loc = __asStr(locationLabel);
  const namedCourt = __asStr(
    session?.courtLabel ||
      session?.externalCourtName ||
      session?.external_court_name,
  );
  const court = Number(session?.courtNo);
  let courtLabel = namedCourt;
  if (!courtLabel && Number.isFinite(court) && court > 0) {
    courtLabel = t("hub.schedule.court", { n: String(court) });
  }
  if (
    loc &&
    courtLabel &&
    Number.isFinite(court) &&
    court > 0 &&
    loc.toLowerCase().includes(`platz ${court}`)
  ) {
    return session?.courtBooked
      ? t("hub.schedule.placeWithBookedCourt", { place: loc })
      : loc;
  }
  if (loc && courtLabel) {
    return session?.courtBooked
      ? t("hub.schedule.placeWithBookedCourt", {
          place: `${loc} · ${courtLabel}`,
        })
      : `${loc} · ${courtLabel}`;
  }
  if (courtLabel && session?.courtBooked) {
    return t("hub.schedule.placeWithBookedCourt", { place: courtLabel });
  }
  return [loc, courtLabel].filter(Boolean).join(" · ");
}
